exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: auto;\r\n  max-width: 200px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/spinner/spinner.component.css
// module id = ../../../../../src/app/shared/spinner/spinner.component.css
// module chunks = 4